module.exports = __webpack_public_path__ + "static/img/butterfly.7d079e9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animated/butterfly.gif
// module id = ZrAB
// module chunks = 0